// Libraries
import { Grid } from "@mui/material";

// Components
import ButtonDirection from "./ButtonDirection";

type TButtonSide = { icon: string; disabled: boolean; onClick: () => void };
type TSwitchButtonAreaProps = {
	moveToLeft: TButtonSide;
	moveToRight: TButtonSide;
};

export default function SwitchButtonArea(props: Readonly<TSwitchButtonAreaProps>) {
	const { moveToLeft, moveToRight } = props;

	const { icon: leftIconDirection, disabled: leftDisabled, onClick: leftOnClick } = moveToLeft;
	const { icon: rightIconDirection, disabled: rightDisabled, onClick: rightOnClick } = moveToRight;

	return (
		<Grid className="mx-4">
			<Grid container direction="column" sx={{ alignItems: "center" }} justifyContent={"flex-end"} gap={1.5}>
				<ButtonDirection direction={"right"} iconDirection={leftIconDirection} disabled={leftDisabled} onClick={leftOnClick} />
				<ButtonDirection direction={"left"} iconDirection={rightIconDirection} disabled={rightDisabled} onClick={rightOnClick} />
			</Grid>
		</Grid>
	);
}
